const STATUS_FFT = {
	COMPLETED: 'completed',
	IN_PROGRESS: 'in_progress',
	MISSING: 'missing',
};

const REGIMES = {
	PLATEC: 'platec',
	SUE_SAL: 'sue_sal',
	RESICO: 'resico',
	ACT_EMP: 'act_emp',
	
};

const OPERATION_TYPES = {
    MONTHLY: 'monthly',
}

export { STATUS_FFT, REGIMES, OPERATION_TYPES };
